module.exports = __webpack_public_path__ + "static/media/6.89a9efa9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/galeria/6.jpeg
// module id = 159
// module chunks = 0